import { GET, request, SearchSelect, useUserContext } from '@talos/kyoko';
import { useQuery } from '@tanstack/react-query';
import { compact, uniq } from 'lodash-es';

interface CurrencyAlias {
  Symbol: string;
}

function useCurrencyAliases(symbol?: string) {
  const { orgApiEndpoint } = useUserContext();

  return useQuery({
    queryKey: ['currency-aliases', symbol],
    queryFn: () =>
      request<{ data: CurrencyAlias[] }>(GET, `${orgApiEndpoint}/currencies/${encodeURIComponent(symbol!)}/aliases`),
    enabled: !!symbol,
    select: data => {
      const responseAliases = data?.data?.map(a => a.Symbol) ?? [];
      return uniq([symbol!, ...responseAliases]);
    },
  });
}

interface AssetAliasSelectorProps {
  selectedCurrency?: string;
  selectedAlias?: string;
  onChange: (alias: string | undefined) => void;
  disabled?: boolean;
}

export function AssetAliasSelector({ selectedCurrency, selectedAlias, onChange, disabled }: AssetAliasSelectorProps) {
  const { data: aliases, isLoading } = useCurrencyAliases(selectedCurrency);
  const options = aliases ?? compact([selectedCurrency]);

  return (
    <SearchSelect
      selection={selectedAlias}
      options={options}
      onChange={onChange}
      getLabel={c => c}
      data-testid="new-transfer-form-alias-currency-select"
      placeholder={isLoading ? 'Loading aliases...' : 'Select Transfer Asset'}
      disabled={disabled || isLoading}
      readOnly={options.length === 1}
      showClear={options.length > 1}
    />
  );
}
